'use client';

import CarouselSection from '@modules/common/components/carousel-section';
import PlayerCard from '@modules/common/components/player-card';
import { TOP_PLAYERS } from '@constants/players';
import type { Player } from '@constants/players';

interface TopPlayersProps {
  /** Custom title (defaults to "Shop by player") */
  title?: string;
  /** Custom section ID (defaults to "shop-by-player") */
  sectionId?: string;
  /** Custom player list (defaults to TOP_PLAYERS from constants) */
  players?: Player[];
}

export default function TopPlayers({ title = 'Shop by player', sectionId = 'shop-by-player', players }: TopPlayersProps) {
  const items = players ?? TOP_PLAYERS;

  return (
    <CarouselSection
      title={title}
      sectionId={sectionId}
      items={items}
      showViewAll
      viewAllHref="/store"
      viewAllText="View all players"
      ariaLabel={title}
      scrollAmount={400}
      gap="gap-4"
      padding="xs"
      titleClassName="text-brand-navy"
      keyExtractor={(item) => item.id}
      renderItem={(player: Player) => (
        <PlayerCard key={player.id} player={player} />
      )}
    />
  );
}
